let storePage
function vueStorePage() {
    storePage = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {

            const store = Vue.reactive({})
            const storeSelector = window.storeSelector()

            const isStoreClosed = Vue.computed(() => !!store?.node?.isClosed)
            const storeClosedToDisplay = Vue.computed(() => storeSelector.formatClosedToDate(store?.node?.closedTo))

            const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

            const getStore = async () => {
                let req = `{
	                locations(first:250,sortKey:NAME) {
		                edges {
			                node {
                                id
				                address {
                                    phone
    					            longitude
	    				            latitude
                                    formatted
                                    provinceCode
                                    city
                                    zip
                                    countryCode
				                }
				                name
                                Hours: metafield(namespace:"location",key:"trading_hours") {
                                    value
                                }
                                mrHours: metafield(namespace:"delivery",key:"hours") {
                                    value
                                }
                                Description: metafield(namespace:"location",key:"store_description") {
                                    value
                                }
                                Image: metafield(namespace:"location",key:"storeImage") {
                                    reference {
                                        ... on MediaImage {
                                            previewImage {
                                                url
                                            }
                                        }
                                    }
                                }
                                closedFrom: metafield(namespace:"store",key:"closed_from") {
                                    value
                                }
                                closedTo: metafield(namespace:"store",key:"closed_to") {
                                    value
                                }
			                }
		                }
    	            }
                }`
                const opts = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                    },
                    body: JSON.stringify({ query: req })
                };

                try {
                    const storesResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, opts);
                    let stores = await storesResponse.json();
                    stores.data.locations.edges = stores?.data?.locations?.edges?.filter(edge => !edge?.node?.name?.includes("pre-order") && !edge?.node?.name?.includes("warehouse"))
                    let storeData = stores.data.locations.edges.map(store => {
                        store.node.phoneLink = `tel:${store.node.address.phone}`
                        store.node.directionLink = `https://maps.google.com.au/maps?q=${store.node.address.latitude},${store.node.address.longitude}&z=15`;
                        store.node.closedFrom = store.node.closedFrom?.value;
                        store.node.closedTo = store.node.closedTo?.value;
                        store.node.isClosed = storeSelector.isLocationClosed(store.node);
                        if (store.node.Hours.value) {
                            store.node.Hours = JSON.parse(store.node.Hours.value)
                            if (store?.node?.Hours?.children[0]?.children[0]?.value) {
                                store.node.Hours = store.node.Hours.children[0].children[0].value.split('\n')
                            }
                        }
                        if (store?.node?.Description?.value) {
                            store.node.Description = store.node.Description.value
                        } else {
                            store.node.Description = false;
                        }
                        if (store?.node?.Image?.reference?.previewImage?.url) {
                            store.node.Image = store.node.Image.reference.previewImage.url
                        } else {
                            store.node.Image = false;
                        }
                        return store
                    });
                    storeSelector.storeList = storeData;
                    let storeSlug = window.location.pathname.replaceAll('/pages/', '').replaceAll('-t-marts', '').replaceAll('/', '')
                    let idx = storeData.findIndex(store => store.node.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') == storeSlug)
                    if (idx > -1) {
                        store.node = storeData[idx].node
                        const { latitude, longitude } = storeData[idx].node.address
                        const lat = Number(latitude), long = Number(longitude)

                        if (lat && long) {
                            const distanceSorted = (storeData || [])
                                .map(entry => {
                                    const entryLat = Number(entry?.node?.address?.latitude)
                                    const entryLong = Number(entry?.node?.address?.longitude)
                                    if (!Number.isFinite(entryLat) || !Number.isFinite(entryLong)) return null
                                    const distance = storeSelector.haversineFormula(lat, long, entryLat, entryLong).toFixed(2)
                                    return { ...entry, distance }
                                })
                                .filter(Boolean)
                                .sort((a, b) => Number(a.distance) - Number(b.distance))

                            let nearby = JSON.parse(localStorage.getItem('storesUnder100') || '[]')
                            if (!Array.isArray(nearby) || nearby.length <= 1) {
                                nearby = (distanceSorted || []).filter(e => Number(e?.distance) <= 100)
                                if (nearby.length) {
                                    storeSelector.storesWithinDistance = nearby
                                    localStorage.setItem('storesUnder100', JSON.stringify(nearby))
                                }
                            }
                        }
                        storeSelector.storeSelect(storeData[idx])
                        const schema = {
                            "@context": "https://schema.org",
                            "@type": "TireShop",
                            "@id": `${window.location.href}#store`,
                            name: store.node.name,
                            url: window.location.href,
                            telephone: store.node.address.phone,
                            address: {
                                "@type": "PostalAddress",
                                streetAddress: store.node.address.formatted,
                                addressLocality: store.node.address.city,
                                postalCode: store.node.address.zip,
                                addressCountry: "AU"
                            },
                            geo: {
                                "@type": "GeoCoordinates",
                                latitude: store.node.address.latitude,
                                longitude: store.node.address.longitude
                            },
                            openingHoursSpecification: [],
                            parentOrganization: {
                                "@id": "https://www.bobjane.com.au/#organization"
                            }
                        }
                        if (store?.node?.mrHours?.value) {
                            try {
                                const hours = JSON.parse(store.node.mrHours.value)
                                if (hours.length > 0) {
                                    hours.sort((a, b) => a.dayInt - b.dayInt);
                                    hours.forEach(h => {
                                        schema.openingHoursSpecification.push({
                                            "@type": "OpeningHoursSpecification",
                                            dayOfWeek: days[h.dayInt],
                                            opens: `${String(h.openHour).padStart(2, '0')}:${String(h.openMinute).padStart(2, '0')}:00`,
                                            closes: `${String(h.closeHour).padStart(2, '0')}:${String(h.closeMinute).padStart(2, '0')}:00`
                                        })
                                    })
                                }
                            } catch (e) { }
                        }
                        const scriptEl = document.createElement('script')
                        scriptEl.type = 'application/json'
                        scriptEl.text = JSON.stringify(schema)
                        document.head.appendChild(scriptEl)
                    }
                    return;
                } catch (error) {
                    console.error(`Error retrieving stores`, error)
                    return;
                }
            }

            getStore()

            return {
                store,
                isStoreClosed,
                storeClosedToDisplay
            }
        }
    })
    storePage.use(window.VueAppGlobals.pinia);
    storePage.mount('#store');
}

if (window.Vue && window.Pinia) {
    vueStorePage();
} else {
    window.addEventListener('vue-ready', vueStorePage);
}
